import { IFilterComplete } from 'src/app/filter-complete/filter-complete';

export class ReferringPhysicianFilter implements IFilterComplete {
  public Name: string;
  public LastName: string;
  public FirstName: string;
  public Id: number;
  public Enrollment: string;
}
